import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_COLLECTIONS,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';

const normalizeText = (value = '') => String(value || '').trim();

export const PROFILE_FACT_REVIEW_DOMAIN = 'profile_fact';
export const PROFILE_FACT_REVIEW_ALLOWED_ACTIONS = ['add_profile_fact', 'ignore'];

export const PROFILE_FACT_FIELDS = Object.freeze([
  'whatHelps',
  'whatCanBeDifficult',
  'earlyWarningSigns',
  'thingsThatUsuallyHelp',
  'thingsToAvoid',
  'safetyConsiderations',
  'communicationStyle',
  'familySupportTips',
]);

export const normalizeProfileFactField = (value = '') => {
  const cleanValue = normalizeText(value);
  return PROFILE_FACT_FIELDS.includes(cleanValue) ? cleanValue : '';
};

export const buildProfileFactReviewCandidate = ({
  origin = {},
  extractedItem = {},
  confidence = '',
  suggestedAction = 'add_profile_fact',
} = {}) => {
  const value = normalizeText(
    extractedItem.value
    || extractedItem.fact
    || extractedItem.title
    || extractedItem.label
    || extractedItem.summary
    || extractedItem.content
    || extractedItem.sourceText
  );
  const field = normalizeProfileFactField(extractedItem.field || extractedItem.profileField);
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || value);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.KNOWLEDGE_ITEM,
    collection: origin.collection || REVIEWABLE_ORIGIN_COLLECTIONS.KNOWLEDGE_ITEMS,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: PROFILE_FACT_REVIEW_DOMAIN,
      label: value || 'Profile fact',
      sourceText,
      allowedActions: PROFILE_FACT_REVIEW_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: {
        field,
        value,
      },
    }),
    extracted: {
      field,
      value,
      sourceText,
    },
  };
};
